import React from "react";
import Slider from "react-slick";
import { PRODUCT_IMAGES } from "pages/dtf-transfers/by-size/data";
import {
  GalleryWrapper,
  GallerySlide,
  GalleryImage,
} from "styles/pages/dtf-transfers/by-size";

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 4500,
  pauseOnHover: true,
  adaptiveHeight: false,
  draggable: true,
  swipe: true,
  fade: true,
  cssEase: "ease-in-out",
};

const ProductGallery = () => (
  <GalleryWrapper>
    <Slider {...sliderSettings}>
      {PRODUCT_IMAGES.map((image) => (
        <GallerySlide key={image.src}>
          <GalleryImage src={image.src} alt={image.alt} />
        </GallerySlide>
      ))}
    </Slider>
  </GalleryWrapper>
);

export default ProductGallery;
